import TrashPage from './TrashPage';

export default TrashPage;
